import {connect, useSelector} from "react-redux";

export const usePostAiPlarformGuard = (platform) => {
    const user = useSelector(state => state.users.user)
    switch (platform) {
        case 'wordpress':return !!user?.analytics_wordpress_integrations?.length;
        case 'linkedin': return !!user?.analytics_linkedin_integrations?.length;
        case 'facebook': return !!user?.analytics_facebook_integrations?.length;
        case 'instagram': return !!user?.analytics_instagram_integrations?.length;
        case 'twitter': return !!user?.analytics_twitter_integrations?.length;
        case 'sharepoint': return !!user?.analytics_sharepoint_integrations?.length;
        case 'tiktok': return !!user?.analytics_tiktok_integrations?.length;
        default: return false;
    }
}
